export default __webpack_public_path__ + "static/media/ReloadIcon.a8b510d7.svg";